import React from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Button,
} from "reactstrap";

const CommonModal = ({
  isOpen,
  toggle,
  title,
  children,
  footer,
  showFooter = true,
  showHeader = true,
  size = "md",
  centered = true,
  backdrop = true,
  keyboard = true,
  className = "",
  onClose,
  closeButton = true,
  htmlContent,
}) => {
  const handleToggle = () => {
    if (onClose) {
      onClose();
    }
    if (toggle) {
      toggle();
    }
  };

  const defaultFooter = (
    <Button color="secondary" onClick={handleToggle}>
      Close
    </Button>
  );

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleToggle}
      size={size}
      centered={centered}
      backdrop={backdrop}
      keyboard={keyboard}
      className={`${className}`}
    >
      {showHeader && (
        <ModalHeader toggle={closeButton ? handleToggle : null}>
          {title}
        </ModalHeader>
      )}
      <ModalBody>
        {htmlContent ? (
          <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
        ) : (
          children
        )}
      </ModalBody>
      {showFooter && (
        <ModalFooter>{footer || defaultFooter}</ModalFooter>
      )}
    </Modal>
  );
};

export default CommonModal;

